<div class="body_container text-grey">
  <h4>Node List</h4>
  <table class="table  main-panel-table" style="white-space: nowrap;" dynamicPagination [rowHeight]="32" [offsetHeight]="200" [paginationInstance]="config">
    <thead>
      <tr class="table-list-head">
        <th scope="col" resizable>#</th>
        <th scope="col" resizable>Deployment</th>
        <th scope="col" resizable>No. of Nodes</th>
        <th scope="col" resizable>Infrastructure</th>
      </tr>
    </thead>
    <tbody>
      <tr class="table-list-row" *ngIf="isGlobalAdmin" (click)="redirectTo(deployments[0], true)"
          style="cursor: pointer">
        <td>-</td>
        <td class="impListName">
          All Nodes
        </td>
        <td>{{ totalNodesOfAllDeployments }}</td>
        <td>NA</td>
      </tr>
      <tr class="table-list-row" *ngFor="let dep of deploymentNullCheck() | paginate: { itemsPerPage: config.itemsPerPage, currentPage: config.currentPage }; let i = index"
          (click)="redirectTo(dep)"
          style="cursor: pointer">
          <td scope="row">
            {{ config.currentPage === 1 ? i + 1 : (config.currentPage - 1) * 10 + (i + 1) }}
          </td>
          <td class="impListName">{{ dep.name }}</td>
          <td>{{ dep.totalNodes }}</td>
          <td>{{ dep.numOfComputeNodes == -1 && dep.headNodeIp == "NA" ?  dep.cloud + ": VDI" : dep.cloud}}</td>
      </tr>
    </tbody>
  </table>
  <pagination-controls *ngIf="deploymentNullCheck()"
                       class="my-pagination ms-auto"
                       (pageChange)="config.currentPage = $event">
  </pagination-controls>
  <p *ngIf="dataEmpty" style="text-align: center; margin-top: 5%;">No Deployment Available.</p>
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               size="default" zIndex="1"
               color="var(--s-primary-color)"
               type="ball-spin"
               [fullScreen]="false"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
</div>
